import { exportMoocsFile } from "../service/content-course/contenCourseApi";

// Type ---
// Khóa học: course,
// Chương: section,
// Bài giảng: sequence,
// Học liệu: unit,
export const handleDownloadMoocsFile = async (id: number, type: string, fileName?: string) => {
  try {
    const res = await exportMoocsFile(id, type);
    if (res.status === 200) {
      const fileData = res.data;
      const blob = new Blob([fileData], {
        type: "application/moocs",
      });
  
      const downloadLink = document.createElement("a");
      downloadLink.href = URL.createObjectURL(blob);
  
      downloadLink.download = `${fileName}.moocs`;
  
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } 
    // message.success("Tải xuống thành công!")
  } catch (err) {
    console.error("Error downloading file:", err);
  }
};
